<template>
  <ul>
    <li
      v-for="(item, index) in pricePlanData.plans"
      :key="hash(item)"
      class="mb-5 last:mb-0"
    >
      <PricePlansCard :default-show="index === 0" :plan-data="item" />
    </li>
  </ul>
</template>

<script setup lang="ts">
  import hash from 'object-hash';

  import { EnumServiceType } from '@/assets/types/api/Products';
  import PricePlansCard from '@/components/Area/Pricing/PricePlansCard.vue';
  import type { IPricePlanData } from '@/stores/pricing/pricingStore';

  interface IProps {
    pricePlanData: IPricePlanData;
  }

  withDefaults(defineProps<IProps>(), {
    pricePlanData: () => {
      return {
        tabId: EnumServiceType.CLOUD_ENSAAS,
        plans: [],
      };
    },
  });
</script>
